import { render } from "./Recommendation.vue?vue&type=template&id=3e1d5f6c&scoped=true"
import script from "./Recommendation.vue?vue&type=script&lang=js"
export * from "./Recommendation.vue?vue&type=script&lang=js"

import "./Recommendation.vue?vue&type=style&index=0&id=3e1d5f6c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1d5f6c"]])

export default __exports__